import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=2dca5c91&"
import script from "./ConfirmDialog.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ConfirmDialog.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports